module.exports = __webpack_public_path__ + "img/hotel_en_oaxaca-arte.958f0e87.svg";